import { faker } from '@faker-js/faker'

import { PreviewQNA } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getPreviewQNA = asBuilder((): PreviewQNA => {
  return {
    question: {
      id: faker.number.int(),
      serviceOfferId: faker.number.int(),
      hospitalId: faker.number.int(),
      content: faker.string.uuid(),
      questionerId: faker.number.int(),
      isPostedByRequestor: faker.datatype.boolean(),
      createdAt: faker.date.past().toISOString(),
      modifiedLastAt: faker.date.past().toISOString(),
      suggestionScore: faker.number.int(),
    },
    answer: {
      id: faker.number.int(),
      questionId: faker.number.int(),
      content: faker.string.uuid(),
      createdAt: faker.date.past().toISOString(),
      modifiedLastAt: faker.date.past().toISOString(),
    },
  }
})
